interface Props {
  width?: number;
  height?: number;
}

export default function Spinner({ width, height }: Props) {
  return (
    <img
      style={{
        width,
        height,
      }}
      src={require("@/assets/img/spinner.svg").default.src}
    />
  );
}
